"use strict";import{css as s}from"lit";const t=s``;export default t;
//# sourceMappingURL=base-card.css.js.map
